export const messagesVoucher = {
  pt: {
      message:{
        segments: {
          create: 'Criar Segmentação'
        }
      }
  },
  es: {
    message:{
      segments: {
        create: 'Crear Segmentación'
      }
    }
  },
  en: {
    message:{
      segments: {
        create: 'Create Segmentation'
      }
    }
  }
}
